import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  rowChecked: {
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: '#ececec',
    '& #kebab': {
      color: '#263057'
    }
  },
  row: {
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ececec',
      '& #kebab': {
        color: '#263057'
      }
    }
  },

  hoverButton: {
    color: '#026873',
    '&:hover': {
      color: '#026873'
    }
  },
  hoverButtonDelete: {
    color: '#AD0707',
    '&:hover': {
      color: '#AD0707'
    }
  },
  itemName: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'start',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '20%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  },
  itemIcon: {
    height: 44,
    width: '5%',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      color: '#026873'
    }
  },
  // itemTypeUser: {
  //   height: 44,
  //   fontFamily: 'Roboto',
  //   fontSize: 14,
  //   fontWeight: 'bold',
  //   color: '#6e7a76',
  //   textAlign: 'center',
  //   '&:hover': {
  //     backgroundColor: '#ececec'
  //   },
  //   textOverflow: 'ellipsis',
  //   width: '15%',
  //   overflow: 'hidden',
  //   whiteSpace: 'nowrap'
  // },
  itemRoleUser: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '10%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  itemEmail: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'start',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '15%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },

  itemDate: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '15%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  },

  itemKebab: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    width: '5%',
    textAlign: 'start',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    '&:hover': {
      backgroundColor: '#ececec'
    }
  },
  kebab: {
    color: '#B3B3B3'
  }
}))

export default useStyles
